export const env = window.ENV ? JSON.parse(atob(window.ENV)) : {};
delete window.ENV;
